(function ($) {

    "use strict";

    jQuery(document).ready(function () {


        // init retina 

        // retinajs();

        // init primary nav

        $('#site-navigation').stellarNav({
            theme: 'light',
            breakpoint: 991,
            closeBtn: false,
            scrollbarFix: true,
            sticky: false,
        });

        // Init search toggle

        $('.search-button').click(function (e) {
            e.preventDefault();
            $('.search-container').slideToggle();
        });

        $('.search-container .search-form .search-field').removeAttr('placeholder');


        // init vinobox for vblog popup


        $('.venobox').venobox();


        // init swiper for main featured banner

        var swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: true,
            speed: 400,
            effect: "slide",
            pagination: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });


        $(".swiper-container").hover(function () {
            swiper.autoplay.stop();
        }, function () {
            swiper.autoplay.start();
        });


        // Init related post carousel

        $('.related_posts_carousel').owlCarousel({
            items: 2,
            loop: true,
            margin: 2.5,
            nav: true,
            rtl: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 1
                },
                992: {
                    items: 2
                },
                1200: {
                    items: 2
                }
            }
        });


        // Init homepage shop swiper

        var swiper_shop = new Swiper('.shop_homepage_container', {
            slidesPerView: 4,
            spaceBetween: 30,
            loop: true,
            pagination: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                991: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                550: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                0: {
                    items: 1,
                    spaceBetween: 30,
                }
            },
        });


        // init Featured post slider


        $('#styleblog-plus-hero-slider').owlCarousel({

            items: 3,
            loop: true,
            lazyLoad: false,
            margin: 2,
            smartSpeed: 800,
            nav: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            responsive: {
                0: {
                    items: 1
                },
                400: {
                    items: 1
                },
                550: {
                    items: 1
                },
                768: {
                    items: 2
                },
                850: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1050: {

                    items: 3
                },
                1200: {
                    items: 3
                }
            },
        });



        // Init instafeed carousel

        $('.feed-carousel').owlCarousel({
            items: 6,
            loop: true,
            margin: 0,
            autoplay: true,
            autoplayTimeout: 3000,
            nav: false,
            dots: false,

            responsive: {
                0: {
                    items: 1
                },
                370: {
                    items: 1
                },
                450: {
                    items: 2
                },
                768: {
                    items: 4
                },
                992: {
                    items: 6
                },
                1200: {
                    items: 6
                }
            }
        });

    });

    // init sticky sidebar

    jQuery('.sticky_portion').theiaStickySidebar({
        additionalMarginTop: 30
    });

    // Scroll Top

    jQuery(window).scroll(function () {
        if ($(this).scrollTop() >= 50) {
            $('#return-to-top').fadeIn(200); // Fade in the arrow
        } else {
            $('#return-to-top').fadeOut(200); // Else fade out the arrow
        }
    });

    jQuery('#return-to-top').click(function () { // When arrow is clicked
        jQuery('body, html').animate({
            scrollTop: 0 // Scroll to top of body
        }, 800);
    });

})(jQuery);